import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme, "theme");

  return {
    id: id,
    elements: [
      {
        type: "text",
        id: "53Gmvx-LCH",
        width: 0.29,
        height: 100,
        left: 161.97092967818833,
        top: 99.50131108462455,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: center;"><strong><span style="font-size: 40px;"><span style="color: rgba(234,232,232,1);">目录</span></span></strong></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "FBZTzoFPFx",
        width: 0.31,
        height: 189.53125,
        left: 242.42384982121575,
        top: 99.50131108462455,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: center;"><span style="font-size: smaller;"><span style="font-family: Arial;"><span style="color: rgba(255,255,255,1);"><sub>CONTENT</sub></span></span></span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "FKQsx5EgLg",
        left: 493.4541792547834,
        top: 137.23308734055047,
        width: 361.664988251091,
        height: 241.921875,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#fff",
        vertical: false,
      },
    ],
    background,
  };
}
